<template>
  <div class="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  computed: {
    user () {
      return this.$store.getters['auth/user']
    },
    analyticsQueue () {
      return this.$store.getters.analyticsQueue
    }
  },
  watch: {
    analyticsQueue () {
      if (this.analyticsQueue.length) {
        try {
          this.$ma.trackEvent(this.analyticsQueue[0])
        } catch (error) {
          console.log('Error cathced', error)
        } finally {
          this.$store.commit('popAnalyticsEvent')
        }
      }
    }
  },
  created () {
    /** Redirecting users from old domain */
    if (window.location.hostname === 'app.getfaraday.com') {
      const path = window.location.pathname
      window.location.href = 'https://app.tapkit.com' + path
    }

    /** Adjusting app to screen size */
    this.onWindowResize()
    window.addEventListener('resize', this.onWindowResize)
  },
  methods: {
    onWindowResize () {
      let width = window.innerWidth
      let height = window.innerHeight
      if (navigator.userAgent.match(/instagram/i)) {
        if (window.screen.width < window.innerWidth) {
          width = window.screen.width
        }
        if (window.screen.height < window.innerHeight) {
          height = window.screen.height
        }
      }
      this.$store.commit('setViewportDimensions', { width: width, height: height })
    }
  }
}
</script>
<style>
.app {
  background: white;
}

.popover--custom {
  left: 60px !important;
  bottom: 35px;
  top: unset !important;
}
</style>
